import type { Contact, ContactState } from "@/types";
import type { MutationTree } from "vuex";

export const LOAD_CONTACT = "LOAD_CONTACT";
export const LOAD_CONTACT_SUCCESS = "LOAD_CONTACT_SUCCESS";
export const LOAD_CONTACT_FAILURE = "LOAD_CONTACT_FAILURE";

export const ADD_CONTACT = "ADD_CONTACT";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAILURE = "ADD_CONTACT_FAILURE";

export const EDIT_CONTACT = "EDIT_CONTACT";
export const EDIT_CONTACT_SUCCESS = "EDIT_CONTACT_SUCCESS";
export const EDIT_CONTACT_FAILURE = "EDIT_CONTACT_FAILURE";

export const DELETE_CONTACT = "DELETE_CONTACT";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAILURE = "DELETE_CONTACT_FAILURE";

export const mutations: MutationTree<ContactState> = {
  // LOAD_CONTACT
  [LOAD_CONTACT](state: ContactState) {
    state.contacts = {
      ...state.contacts,
      loading: true,
      error: null,
    };
  },
  [LOAD_CONTACT_SUCCESS](state: ContactState, data: any) {
    state.contacts = {
      data: [...data.contacts],
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_CONTACT_FAILURE](state: ContactState, error: string) {
    state.contacts = {
      ...state.contacts,
      loading: false,
      error: error,
    };
  },

  // ADD_CONTACT
  [ADD_CONTACT](state: ContactState) {
    state.contacts = {
      ...state.contacts,
      loading: true,
      error: null,
    };
  },
  [ADD_CONTACT_SUCCESS](state: ContactState, contact: Contact) {
    state.contacts = {
      count: state.contacts.count + 1,
      data: [...state.contacts.data, ...[contact]],
      loading: false,
      error: null,
    };
  },
  [ADD_CONTACT_FAILURE](state: ContactState, error: string) {
    state.contacts = {
      ...state.contacts,
      loading: false,
      error: error,
    };
  },

  // EDIT_CONTACT
  [EDIT_CONTACT](state: ContactState) {
    state.contacts = {
      ...state.contacts,
      loading: true,
      error: null,
    };
  },
  [EDIT_CONTACT_SUCCESS](state: ContactState, contact: Contact) {
    state.contacts.loading = false;
    state.contacts.error = null;
    state.contacts.data[
      state.contacts.data.findIndex((cnt: Contact) => cnt.id === contact.id)
    ] = { ...contact };
  },
  [EDIT_CONTACT_FAILURE](state: ContactState, error: string) {
    state.contacts = {
      ...state.contacts,
      loading: false,
      error: error,
    };
  },

  // DELETE_CONTACT
  [DELETE_CONTACT](state: ContactState) {
    state.contacts = {
      ...state.contacts,
      loading: true,
      error: null,
    };
  },
  [DELETE_CONTACT_SUCCESS](state: ContactState, contactId: string) {
    state.contacts = {
      data: [...state.contacts.data].filter(
        (cnt: Contact) => cnt.id !== contactId,
      ),
      count: state.contacts.count - 1,
      loading: false,
      error: null,
    };
  },
  [DELETE_CONTACT_FAILURE](state: ContactState, error: string) {
    state.contacts = {
      ...state.contacts,
      loading: false,
      error: error,
    };
  },
};
